module.exports = __webpack_public_path__ + "img/标准版.1267a5f5.png";